import { globalHistory } from '@reach/router'

const getParams = (data) => {
  const searchParam = new URLSearchParams(globalHistory.location.search);
  return Array.isArray(data) ? data.map(key =>  searchParam.get(key) ) : searchParam.get(data)
}; 

export default getParams;
